import { Stack } from '@mui/material';
import { CasRHFTextField, CasRHFSwitch, CasStackRow } from 'src/compass/shared/components';

import { CasRHFEmployeeSelect } from '../../../general/components/CasEmployeeSelect';
import { RHFBranchSelect } from './_internal/BranchSelect';
import EmployeeFlagFields from './_internal/EmployeeFlagFields';

// ----------------------------------------------------------------------

type EmployeeFieldsProps = {
  // Where the employee sits in the form's values, e.g. "employee." on the user form
  namePrefix?: string;
};

// An Employee's own fields, for the Employees tab's form and the user form's Employee tab
export default function EmployeeFields({ namePrefix = '' }: EmployeeFieldsProps) {
  return (
    <>
      <CasRHFTextField name={`${namePrefix}shortName`} label="Short Name" />

      <RHFBranchSelect name={`${namePrefix}branchId`} label="Branch" />
      <CasRHFEmployeeSelect
        name={`${namePrefix}managerEmployeeId`}
        label="Manager"
        includeNoneOption
      />

      <CasRHFTextField name={`${namePrefix}docusignUser`} label="Docusign User" />
      <CasRHFTextField name={`${namePrefix}sceEntryCCEmail`} label="SCE CC" />
      <CasRHFTextField
        type="number"
        name={`${namePrefix}payrollEmpNbr`}
        label="Payroll Key (Emp#)"
      />
      <CasStackRow>
        <Stack flex={1}>
          <EmployeeFlagFields namePrefix={namePrefix} />
          <CasRHFSwitch name={`${namePrefix}is1099`} label="Is 1099?" />
        </Stack>
        <Stack flex={1}>
          <CasRHFSwitch name={`${namePrefix}isBoardMbr`} label="Is Board Mbr?" />
          <CasRHFSwitch name={`${namePrefix}isSalesOrOther`} label="Is Sales/Other?" />
          <CasRHFSwitch name={`${namePrefix}isLRPProcessor`} label="Is LRP Processor?" />
        </Stack>
      </CasStackRow>
      <CasRHFSwitch name={`${namePrefix}isActive`} label="Active" />
    </>
  );
}
